import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { View } from "@/components/ui/view";
import { Modal, ModalContent, ModalCloseButton } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import React from 'react'
import i18n from "i18n-js";
import { IconMC } from "@/components/media/IconsV2";

export default function ExportModal({ showModal, closeModal, workflowTitle, success }) {
    return (
        <Modal isOpen={showModal} onClose={() => { closeModal() }}>
            <ModalContent maxWidth='1000px'>
                <ModalCloseButton>
                    <View className='bg-primary-50 border-2 border-primary-900 rounded-[4px] p-1 w-fit self-end'>
                        <IconMC className='text-primary-900' size={24} name='close' />
                    </View>
                </ModalCloseButton>
                <VStack space='lg' className='p-3'>
                    <Text bold className='text-secondary-900 text-2xl'>{success ? i18n.t('studio.flow.exportSuccess') : i18n.t('studio.flow.exportFail')}</Text>
                    <Text className='text-xl text-secondary-900'>{success ? i18n.t('studio.flow.exportSuccessMessage', { title: workflowTitle }) : i18n.t('studio.flow.exportFailMessage')}</Text>
                    <Button onPress={() => { closeModal() }} className='self-end w-[150px] bg-primary-900 py-3 px-5'>
                        <Text className='text-lg text-secondary-50'>{i18n.t('global.ok')}</Text>
                    </Button>
                </VStack>
            </ModalContent>
        </Modal>
    );
}
